export const SOURCE_SCHEMA_STORE_KEY = 'sourceSchema';
export const SOURCE_SCHEMA_SERVICE_KEY = 'sourceSchema';
export const SOURCE_SCHEMA_API_URL = '/api/v1/source/';
